import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import iTerminal from '../../../components/TerminalTable.vue'
import { domainName, processFile } from "../../../utility/index"
import moment from 'moment';

export default {
    name: "EquipmentControl",
    components: { tree, iTable, IPagination, iTerminal },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                carId: '',
                terminalId: '',
                terminalType: '',
                aliKey: '',
                OperatingTime: [],
            },
            terminalList: [
            ],
            aliKeyList: [
                { id: '', name: this.$t('common.all') }
            ],
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [
                {
                    prop: "serialNumber",
                    label: this.$t('SafeManagement.serialNumber'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "terminalTypeName",
                    label: this.$t('SafeManagement.terminalTypeName'),
                    align: "center",

                },
                {
                    prop: "aliKey",
                    label: this.$t('SafeManagement.aliKey'),
                    align: "center",
                    width: "120px"
                },

                {
                    prop: "keyName",
                    label: this.$t('SafeManagement.keyName'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "sendContent",
                    label: this.$t('SafeManagement.sendContent'),
                    align: "center",
                    width: "400px"
                },
                {
                    prop: "lastUser",
                    label: this.$t('common.lastUser'),
                    align: "center",
                    width: "100px"
                },
                {
                    prop: "createTime",
                    label: this.$t('common.createTime'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "receivedTime",
                    label: this.$t('SafeManagement.receivedTime'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "state",
                    label: this.$t('SafeManagement.state'),
                    align: "center",
                    fixed: 'right',
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.state === 0 ? 'info' : params.row.state === 1 ? 'success' : params.row.state === 2 ? 'warning' : 'danger' }
                        }, params.row.state === 0 ? this.$t('common.btn.cancel') : params.row.state === 1 ? this.$t('SafeManagement.success') : params.row.state === 2 ? this.$t('SafeManagement.sending') : this.$t('SafeManagement.exceedFail'))
                    }

                }
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10, 
            total: 1, 
            dialogFormVisible: false,
            formLabelWidth: '112px',
            rules: {
                terminalType: [
                    { required: true, message: this.$t('common.form.terminalType') , trigger: 'change' }
                ], 
                keyId: [
                    { required: true, message: this.$t('common.form.keyId') , trigger: 'change' }
                ],
                sendContent: [
                    { required: true, message: this.$t('common.form.terminalId') , trigger: 'blur' }
                ],

            },
            form: {
                terminalType: '',
                terminalId: '',
                groupId: '0',
                keyId: '',
                sendContent: '',
                file: ''
            },
            groupStatus: true,
            placeholder: '',
            dialogVisibleTransfer: false,
            selected: [],
            dialogServiceFormVisible: false,
            serviceRules: {
                terminalType: [
                    { required: true, message: this.$t('common.form.terminalType') , trigger: 'change' }
                ], 
                keyId: [
                    { required: true, message: this.$t('SafeManagement.form.selectServerSet'), trigger: 'blur' }
                ],
            },
            serviceForm: {
                terminalType: '',
                terminalId: '',
                groupId: '0',
                keyId: '',
                sendContent: {},
                file: ''
            },
            serviceList: [
                
            ],
            voiceStatus: true,
            WIFIStatus: false,
            initialStatus: false,
            dialogRetryFormVisible: false,
            retryRules: {},
            retryForm: {
                serialNumber: ''
            },
            formRetryLabelWidth: '60px',
            delDisabled: true,
            uploadTerminal: {},
            FileList: [],
            FileLists: [],
            processFile: processFile,
            terminalValue: '',
            terminalMsg: '',
            delTransfer: true,
            isShowDialong: false,
            paramsData: null
        }
    },
    created() {
        this.getDate()
        this.getTerminalType()
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        getDate() {
            const endTime = moment().format("YYYY-MM-DD");
            const startTime = moment().startOf("month").format("YYYY-MM-DD");
            this.formInline.OperatingTime = [startTime, endTime];
        },
        getNewCarInfo() {
            this.dialogVisibleTransfer = true
            this.delTransfer = false
            this.isShowDialong = true
            this.$nextTick(() => {
                this.delTransfer = true
            })
        },
        getCarInfo() {
            this.dialogVisibleTransfer = true
            this.delTransfer = false
            this.isShowDialong = true
            this.$nextTick(() => {
                this.delTransfer = true
            })
        },
        changeStatus(val) {
            if (val == 0) {
                this.groupStatus = true
            } else {
                this.groupStatus = false
            }
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getInstructList()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getInstructList()
        },
        getInstructList() {
            let param = {
                isShowHidden: 1,
                orgId: this.id,
                carId: this.formInline.carId,
                terminalId: this.formInline.terminalId,
                terminalType: this.formInline.terminalType,
                aliKey: this.formInline.aliKey,
                startTime: this.formInline.OperatingTime[0],
                endTime: this.formInline.OperatingTime[1],
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('EquipmentControl/GET_QUERYINSTRUCTLIST', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        getTerminalType() {
            this.$store.dispatch('TerminalCommand/GET_TERMINALTYPE', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.terminalList = res.data.data
                    }
                }
            }).catch(err => { })
        },
        indexSelect(type) {
            this.paramsData = this.form.terminalType
            let typeId;
            if (type == 'query') {
                typeId = this.formInline.terminalType
            } else {
                typeId = this.form.terminalType
            }
            this.aliKeyList = [
                { id: '', name: this.$t('common.all') }
            ]
            let param = {
                typeId: typeId,
                state: 1,
                keyType: 1,
            }
            this.$store.dispatch('EquipmentControl/GET_QUERYBYTYPE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.aliKeyList = this.aliKeyList.concat(res.data.data)
                    }
                }
            }).catch(err => { })
        },
        getTypeKey(val) {
            this.aliKeyList.map(item => {
                if (item.id == val) {
                    this.placeholder = item.explain
                }
            })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getInstructList()
        },
        onClear() {
            this.formInline = {
                carId: '',
                terminalId: '',
                terminalType: '',
                aliKey: '',
            }
            this.getDate()
            this.getInstructList()
        },
        addSimple() {
            this.dialogFormVisible = true
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let formData = new FormData()
                    formData.append('terminalType', this.form.terminalType)
                    formData.append('terminalId', this.form.terminalId)
                    formData.append('keyId', this.form.keyId)
                    formData.append('sendContent', this.form.sendContent)
                    formData.append('file', this.form.flie)
                    this.$store.dispatch('EquipmentControl/GET_ADDBRIEFNESSINSTRUCT', formData).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.addSuccess'))
                            this.dialogFormVisible = false;
                            this.getInstructList();
                            this.closeDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })


                } else {
                    return false;
                }
            });
        },
        handleSuccess(res, file) {
            console.log(res.file)
            const arr = []
            this.FileList.push({
                name: res.name,
                url: res.data,
                uid: res.uid
            })

            this.FileList.map(item => {
                arr.push(item.url)
            })
            this.form.terminalId = arr.join(',')

        },
        handleRemove(file, fileList) {
            this.FileList = []
            const arr = []
            fileList.map(item => {
                this.FileList.push({
                    name: item.name,
                    url: item.url,
                    uid: item.uid
                })
                arr.push(item.url)
            })
            this.form.terminalId = arr.join(',')
        },
        handlePreview(file) {
            console.log(file);
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.isShowDialong = false
            this.form = {
                terminalType: '',
                terminalId: '',
                groundId: '0',
                keyId: '',
                sendContent: ''
            }
        },
        closeDia() {
            this.paramsData = null
            this.form = {
                terminalType: '',
                terminalId: '',
                groundId: '0',
                keyId: '',
                sendContent: ''
            }
            this.dialogFormVisible = false;
            this.isShowDialong = false
        },
        postParam(item) {
            if (item.length > 0) {
                item.map((t, index) => {
                    if (index == 0) {
                        this.checkList = t.terminalId
                    } else {
                        this.checkList = this.checkList + ',' + t.terminalId
                    }
                })
            } else {
                this.checkList = ''
            }
        },
        
        assignment() {
            this.form.terminalId = this.checkList
            this.serviceForm.terminalId = this.checkList
            this.dialogVisibleTransfer = false
        },
        handleClose() {
            this.dialogVisibleTransfer = false
        },
        addComplex() {
            this.dialogServiceFormVisible = true
            this.$nextTick(() => {
                this.$refs.serviceForm.resetFields()
            })
            this.voiceStatus = false
            this.WIFIStatus = false
            this.initialStatus = false
        },
        getService(val) {
            console.log(val)
            if (val == 'VOICE') {
                this.voiceStatus = true
                this.WIFIStatus = false
                this.initialStatus = false
                this.serviceForm.sendContent = {
                    TTS_STRING: '',
                    TTS_CNT: '',
                }
            } else if (val == 'WIFI') {
                this.WIFIStatus = true
                this.voiceStatus = false
                this.initialStatus = false
                this.serviceForm.sendContent = {
                    SSID: '',
                    PWD: '',
                }
            } else if (val == 'Restore') {
                this.initialStatus = true
                this.voiceStatus = false
                this.WIFIStatus = false
                this.serviceForm.sendContent = {
                    PASSWORD: ''
                }
            }
        },
        submitServiceForm(serviceFormName) {
            this.$refs[serviceFormName].validate((valid) => {
                if (valid) {
                    if (this.serviceForm.sendContent.TTS_CNT) {
                        this.serviceForm.sendContent.TTS_CNT = Number(this.serviceForm.sendContent.TTS_CNT)
                    }
                    if (this.serviceForm.sendContent.PASSWORD) {
                        this.serviceForm.sendContent.PASSWORD = Number(this.serviceForm.sendContent.PASSWORD)
                    }
                    this.sendContent = JSON.stringify(this.serviceForm.sendContent)
                    let formData = new FormData()
                    formData.append('terminalType', this.serviceForm.terminalType)
                    formData.append('terminalId', this.serviceForm.terminalId)
                    formData.append('keyId', this.serviceForm.keyId)
                    formData.append('sendContent', this.sendContent)
                    formData.append('file', this.serviceForm.flie)
                    this.$store.dispatch('EquipmentControl/GET_ADDCOMPLEXINSTRUCT', formData).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.addSuccess'))
                            this.dialogServiceFormVisible = false;
                            this.getInstructList();
                            this.closeServiceDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })


                } else {
                    return false;
                }
            });
        },
        handleServiceSuccess(res, file) {
            const arr = []
            this.FileLists.push({
                name: res.name,
                url: res.data,
                uid: res.uid
            })

            this.FileLists.map(item => {
                arr.push(item.url)
            })
            this.serviceForm.terminalId = arr.join(',')
        },
        handleServiceRemove(file, fileList) {
            this.FileLists = []
            const arr = []
            fileList.map(item => {
                this.FileLists.push({
                    name: item.name,
                    url: item.url,
                    uid: item.uid
                })
                arr.push(item.url)
            })
            this.serviceForm.terminalId = arr.join(',')
        },
        handleServicePreview(file) {
            console.log(file);
        },
        indexService() {
            this.paramsData = this.serviceForm.terminalType
            let param = {
                typeId: this.serviceForm.terminalType,
                keyType: 2,
                isShow: 1,
                state: 1
            }
            this.$store.dispatch('EquipmentControl/GET_QUERYBYTYPE', param).then(res => {
                if (res) {
                    console.log(res.data)
                    if (res.data.code == 200) {
                        this.serviceList = res.data.data
                    }
                }
            }).catch(err => { })
        },
        closeServiceDia() {
            this.dialogServiceFormVisible = false
            this.isShowDialong = false
            this.paramsData = null
            this.serviceForm = {
                terminalType: '',
                terminalId: '',
                groupId: '0',
                keyId: '',
                sendContent: {
                    TTS_STRING: '',
                    TTS_CNT: '',
                    SSID: '',
                    PWD: '',
                    PASSWORD: ''
                },
            }
        },
        cancleService() {
            this.dialogServiceFormVisible = false
            this.isShowDialong = false
            this.serviceForm = {
                terminalType: '',
                terminalId: '',
                groupId: '0',
                keyId: '0',
                sendContent: {
                    TTS_STRING: '',
                    TTS_CNT: '',
                    SSID: '',
                    PWD: '',
                    PASSWORD: ''
                },
            }
        },
        retry() {
            this.dialogRetryFormVisible = true
            this.retryForm.serialNumber = this.selected.map(item => item.serialNumber).join()
        },
        submitRetryForm(retryFormName) {
            this.$refs[retryFormName].validate((valid) => {
                if (valid) {
                    let param = {
                        serialNumber: this.retryForm.serialNumber
                    }
                    this.$store.dispatch('EquipmentControl/GET_RETRY', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('SafeManagement.form.retrySuccess'))
                            this.dialogRetryFormVisible = false;
                            this.getInstructList();
                            this.closeRetryDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })


                } else {
                    return false;
                }
            });
        },
        closeRetryDia() {
            this.dialogRetryFormVisible = false
        },
        cancleRetry() {
            this.dialogRetryFormVisible = false
        },
        CancelSend() {
            this.$confirm(this.$t('common.btn.confirmCancel'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { serialNumber: this.selected.map(item => item.serialNumber).join() }
                    this.$store.dispatch('EquipmentControl/GET_CANCEL', param).then(response => {
                        if (response.data.code == 200) {
                            this.getInstructList()
                            this.$message.success(this.$t('common.btn.cancelSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        BulkImport() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportTerminalIdModel`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportTerminalIdModel`
                    location.href = url
                }
            }
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let startTime = ''
                    let endTime = ''
                    if (this.formInline.OperatingTime) {
                        if (this.formInline.OperatingTime.length > 0) {
                            startTime = this.formInline.OperatingTime[0]
                            endTime = this.formInline.OperatingTime[1]
                        }
                    }
                    let url = `https://${domainName}/v1/getExportExcel/exportInstructList?isShowHidden=${1}&orgId=${this.id}&carId=${this.formInline.carId}&terminalId=${this.formInline.terminalId}&terminalType=${this.formInline.terminalType}&aliKey=${this.formInline.aliKey}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportInstructList?isShowHidden=${1}&orgId=${this.id}&carId=${this.formInline.carId}&terminalId=${this.formInline.terminalId}&terminalType=${this.formInline.terminalType}&aliKey=${this.formInline.aliKey}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
            val.map(item => {
                console.log(item.state)
                if (item.state == 2) {
                    this.delDisabled = false
                } else {
                    this.delDisabled = true
                }
            })
        },
        changeSize(item) {
            console.log(item)
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getInstructList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}